<template>
    <div>
        <label class="pb-2">{{field.etiqueta}}</label>
        <gmap-map
            :center="center"
            :zoom="zoom"
            style="width:100%;  height: 400px;"
            @
        >
            <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="center=m.position"
                draggable
                @dragend="dragEnd"
            ></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
        libraries: ''
    }
})

export default {
    name: "Map",
    props: ['field', 'readonly', 'label', 'formValues'],
    data(){
        return {
            center: { lat: 45.508, lng: -73.587 },
            markers: [],
            zoom: 16,
            currentPlace: null
        }
    },

    mounted() {
        console.log('mounted ...')
        //this.geolocate();

        if (!this.formValues[this.field.nombre]){
            this.initDefaultValues()
        }else{
            this.initWithSavedValues()
        }
    },

    methods: {
        setPlace(place) {
            this.currentPlace = place;
        },
        initDefaultValues() {
            this.zoom = parseInt(this.field.extra.init_zoom)

            const marker = {
                lat: parseFloat(this.field.extra.init_lat),
                lng: parseFloat(this.field.extra.init_lng),
            };

            if (this.field.extra.marker == '1'){
                this.markers.push({ position: marker });
            }

            this.center = marker;
            this.currentPlace = null;

            this.updateValue()
        },

        initWithSavedValues(){
            let values = JSON.parse(this.formValues[this.field.nombre])

            if (values.length > 0){
                this.zoom = values[0].point.zoom
                this.center = values[0].point.center

                if (this.field.extra.marker == '1'){
                    this.markers.push({ position: values[0].point.marker });
                }
            }else {
                this.initDefaultValues()
            }
        }
        /*,
        geolocate: function() {
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
            });
        }*/
        ,

        dragEnd(position){
            this.center = position.latLng
            this.updateValue()

            console.log(position)
        },

        updateValue(){
            let value = [
                {
                    point: {
                        center: this.center,
                        zoom: this.zoom,
                        marker: this.markers[0]
                    },
                    poligono: {
                        center: this.center,
                        zoom: this.field.extra.init_zoomPol,
                        points: JSON.parse(this.field.extra.init_coord_polygon)
                    }

                }
            ]

            this.formValues[this.field.nombre] = JSON.stringify(value)
        }
    }
}
</script>